export default __webpack_public_path__ + "static/media/miguel-lopes-7.db649d25.jpg";